import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export default styled(Box)`
  .title {
    font-weight: bold;
  }
`;
